import { render, staticRenderFns } from "./subscription.vue?vue&type=template&id=c5d20dd2&"
import script from "./subscription.vue?vue&type=script&lang=js&"
export * from "./subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports